import { render } from "./AppPrelaunch.vue?vue&type=template&id=6245204b"
import script from "./AppPrelaunch.vue?vue&type=script&lang=js"
export * from "./AppPrelaunch.vue?vue&type=script&lang=js"

import "./AppPrelaunch.vue?vue&type=style&index=0&id=6245204b&lang=scss"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__